<template>
  <div class="mb-2">
    <div class="row align-items-start">
      <div class="col font-weight-bold">
        {{ record.label ? record.label : showUntitledLabel ? untitledRecord : "" }}
        <span v-if="isRequired" class="font-weight-regular custom-asterisk-added">
          &#42;
        </span>
        <PrivateTooltip v-if="record.isPrivate"></PrivateTooltip>
      </div>
      <div v-if="record.allowReplica" class="col-12 col-sm-auto d-flex justify-content-sm-end mt-2 mt-sm-0">
        <div class="btn btn-outline-secondary btn-sm" @click="handleClone()">
          <i class="fa-regular fa-clone fa-rotate-180"></i>
          <span>Duplicate</span>
        </div>
      </div>
    </div>
    <div v-if="record.description" class="row">
      <div class="col">
        <span class="text-muted">
          {{ record.description }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import PrivateTooltip from "../common/PrivateTooltip.vue";

export default {
  name: "RecordTitleHint",
  props: {
    record: {
      type: Object,
      required: true,
    },
    showUntitledLabel: {
      type: Boolean,
      default: true,
    },
    untitledRecord: {
      type: String,
      default: "",
    }
  },
  components: {
    PrivateTooltip
  },
  computed: {
    isRequired() {
      return this.record.validators.filter((validator) => {
        return validator.validatorType === 'isRequired' && validator.value;
      }).length > 0
    },
  },
  methods: {
    handleClone() {
      this.$emit('duplicateRecord', this.record)
    }
  },
};
</script>
